import { render, staticRenderFns } from "./RecruitTempPost.vue?vue&type=template&id=2643480a&scoped=true&"
import script from "./RecruitTempPost.vue?vue&type=script&lang=js&"
export * from "./RecruitTempPost.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTempPost.vue?vue&type=style&index=0&id=2643480a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643480a",
  null
  
)

export default component.exports